export class DashboardResponseDTO{
    CountLocations: string;
    CountUsers: string;
    CountRoutes: string;
    CountGeocercas: string;
}